import React, { useEffect, useState } from 'react';
import FullPageSyncLoader from 'components/FullPageSyncLoader';
import { useParams } from 'react-router-dom';
import SectionWrapper from 'components/SectionWrapper/SectionWrapper';

import OnboardingPerfilDeConsumo from 'types/models/onboardingPertfilConsumo';
import OnboardingPerfilDeConsumoInstance from 'services/remote/OnboardingPerfildeConsumo';
import styles from './MatcherListPage.module.scss';
import { OnboardingPerfilConsumoListTable } from './onboarding-perfil-consumo-list-table/onboarding-perfil-consumo-list-table';

interface ParameterDetalles {
  solicitudID: string;
}

export const OnboardingListPage = (): JSX.Element => {
  // const [AllSolicitudes, setAllSolicitudes] = useState<ActualizarTarifaAll[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadingData, setLoadingData] = useState<boolean>(true);
  const { solicitudID } = useParams<ParameterDetalles>();
  const [onboardingPerfilDeConsumo, setOnboardingPerfilDeConsumo] = useState<Array<OnboardingPerfilDeConsumo>>([]);
  const [modifcado, setModificado] = useState('Default');

  const getOnboardingPerfilDeConsumo = async (): Promise<void> => {
    setLoadingData(true);
    try {
      const apiData = await OnboardingPerfilDeConsumoInstance.getAllPerfilesDeConsumo();
      setOnboardingPerfilDeConsumo(apiData);
      setModificado('Default');
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        setOnboardingPerfilDeConsumo([]);
      }
    }

    setLoadingData(false);
  };

  useEffect(() => {
    getOnboardingPerfilDeConsumo();
  }, [modifcado]);

  return (
    <div className={solicitudID !== undefined ? styles.container : styles.container2}>
      <SectionWrapper>
        {loadingData ? (
          <FullPageSyncLoader icon />
        ) : (
          <OnboardingPerfilConsumoListTable
            onChange={setModificado}
            data={onboardingPerfilDeConsumo}
            solicitudID={solicitudID}
          />
        )}
      </SectionWrapper>
    </div>
  );
};
